import { render, staticRenderFns } from "./topicDetails.vue?vue&type=template&id=0e1c5b93&scoped=true&"
import script from "./topicDetails.vue?vue&type=script&lang=js&"
export * from "./topicDetails.vue?vue&type=script&lang=js&"
import style0 from "./topicDetails.vue?vue&type=style&index=0&id=0e1c5b93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c5b93",
  null
  
)

export default component.exports